<!-- version 2021/05/20 -->
<template>
    <p>{{ text }}</p>
</template>

<script>
    export default {
        props: {
            text: String
        }
    }
</script>

<style lang="sass" scoped>
    p
        font-weight: 300
        color: #002832
        font-size: 16px
</style>